import React from "react";
import { useSelector } from "react-redux";
import {
  selectTabData,
  selectTabLoading,
} from "../../../../../../features/dynamicSlice";
import { FaRupeeSign } from "react-icons/fa"; // For Rupee icon

const ProjectedRevenueCard = ({ branchIds, startDate, endDate }) => {
  const projectedRevenue = useSelector((state) => {
    let total = 0;
    const data = selectTabData(state, "projectedRevenue");

    if (!data || !data.branches) return total;

    if (branchIds.includes("all")) {
      data.branches.forEach((branch) => {
        if (branch.totalProjectedRevenue) {
          total += Number(branch.totalProjectedRevenue);
        }
      });
    } else {
      branchIds.forEach((branchId) => {
        const branch = data.branches.find((b) => b.branchId === branchId);
        if (branch && branch.totalProjectedRevenue) {
          total += Number(branch.totalProjectedRevenue);
        }
      });
    }

    return total;
  });

  const loading = useSelector((state) =>
    selectTabLoading(state, "projectedRevenue")
  );

  return (
    <div className="bg-gradient-to-br from-purple-600 via-indigo-600 to-blue-500 text-white rounded-xl shadow-xl p-6 transform hover:scale-105 transition-transform duration-300 ease-in-out w-[20rem]">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-lg font-semibold uppercase tracking-wide">
          Projected Revenue
        </h4>
        <FaRupeeSign className="text-2xl" />
      </div>
      <div>
        {loading ? (
          <p className="text-sm animate-pulse">Loading...</p>
        ) : (
          <p className="text-3xl font-bold">
            {Number(projectedRevenue).toLocaleString()}
          </p>
        )}
      </div>
    </div>
  );
};

export default ProjectedRevenueCard;
